module.exports = __webpack_public_path__ + "static/img/海王星辰.e7334f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/pc/cooperation/outer/海王星辰.png
// module id = fYtX
// module chunks = 0 1 2 9